"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.date.today': 'Dzisiaj',
    'conversations.date.yesterday': 'Wczoraj',
    'conversations.date.daysAgo': '{days} dni temu',
};
